module.exports = __webpack_public_path__ + "img/162.2f8a9249.jpg";